import MDEditor from '@uiw/react-md-editor';

import { useTheme } from '@/lib/theme/theme-context';

export function MarkdownEditor({
  id,
  value,
  onChange,
  required = true,
}: {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}) {
  // MDEditor reads light/dark off the nearest data-color-mode ancestor.
  const { theme } = useTheme();
  return (
    <div data-color-mode={theme} className="rounded-md border">
      <MDEditor
        value={value}
        onChange={(next) => onChange(next ?? '')}
        height={420}
        preview="live"
        textareaProps={{ id, required }}
      />
    </div>
  );
}

export function MarkdownView({ value }: { value: string }) {
  const { theme } = useTheme();
  return (
    <div data-color-mode={theme} className="max-h-[32rem] overflow-auto rounded-md border p-4">
      <MDEditor.Markdown source={value} />
    </div>
  );
}

// Inline markdown for transcript messages: no border/box, sized to the surrounding
// text so it sits flush with the chat bubble it lives in.
export function MarkdownProse({ value }: { value: string }) {
  const { theme } = useTheme();
  return (
    <div data-color-mode={theme}>
      <MDEditor.Markdown source={value} className="!bg-transparent text-sm" />
    </div>
  );
}
